/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CashStack = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 8V20H4V17.5H5.5V18.5H21.5V9.5H20.5V8H23ZM19 4V16H1V4H19ZM17.5 5.5H2.5V14.5H17.5V5.5ZM10.674 6.802V7.432C11.542 7.593 12.095 8.167 12.13 8.993H10.94C10.891 8.741 10.618 8.454 10.17 8.454C9.827 8.454 9.61 8.587 9.61 8.825C9.61 9.035 9.778 9.14 10.037 9.21L10.737 9.406C11.486 9.616 12.144 9.938 12.144 10.995C12.144 11.807 11.577 12.381 10.674 12.514V13.158H9.694V12.493C8.791 12.311 8.21 11.646 8.175 10.701H9.372C9.407 11.135 9.771 11.485 10.233 11.485C10.625 11.485 10.898 11.303 10.898 11.03C10.898 10.792 10.695 10.652 10.422 10.575L9.722 10.386C8.98 10.183 8.364 9.805 8.364 8.832C8.364 8.132 8.903 7.593 9.694 7.432V6.802H10.674ZM16 9.25V10.75H14V9.25H16ZM6 9.25V10.75H4V9.25H6Z"
                        fill={color}
                    />
                </svg>
        );
    };
